
const menuBeam = () => {

    const menuLinks = document.querySelectorAll('.beam-menu .link-item');
    const actionItems = document.querySelectorAll('.beam-actions .action-item');

    let isScrollingClick = false;

    menuLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();

            const targetId = this.getAttribute('href');
            const targetElement = document.querySelector(targetId);

            if (targetElement) {
                isScrollingClick = true;

                setActiveClass(targetId);

                //Pobieram pzoycję elementu
                const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
                const offsetPosition = elementPosition - (window.innerHeight / 2);

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });

                setTimeout(() => {
                    isScrollingClick = false;
                }, 800);
            }
        });
    });

    function setActiveClass(targetId) {
        menuLinks.forEach(item => {
            if (item.getAttribute('href') === targetId) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });

        actionItems.forEach(item => {
            if (`#${item.id}` === targetId) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });
    }

    const observerOptions = {
        root: null,
        rootMargin: '-50% 0px -50% 0px',
        threshold: 0
    };

    const observerCallback = (entries) => {
        if (isScrollingClick) return;

        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const currentId = `#${entry.target.id}`;
                setActiveClass(currentId);
            }
        });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    actionItems.forEach(item => observer.observe(item));
}

export { menuBeam };